import React from 'react';
import {
  SignIn as BaseSignIn
} from 'aws-amplify-react';
import SignInForm from './SignIn/SignInForm';
import AuthWrapper from './AuthWrapper';

export default class SignIn extends BaseSignIn {
  componentDidUpdate(prevProps) {
    if (prevProps.authState !== this.props.authState && prevProps.authState === 'signIn') {
      this.setState({
        working: false,
        errorMessage: false
      });
    }
  }

  error = errorMessage => {
    setTimeout(() => {
      this.setState({
        working: false,
        errorMessage: this.errorMessage(errorMessage)
      });
    }, 1000);
  };

  handleSubmit = ({ email, password }) => {
    this.inputs.username = email;
    this.inputs.email = email;
    this.inputs.password = password;

    this.setState({
      working: true,
      errorMessage: false,
    }, () => {
      this.signIn();
    });
  };

  showComponent() {
    const {
      hide
    } = this.props;
    const {
      working = false,
      errorMessage = false
    } = this.state || {};
    if (hide && hide.includes(SignIn)) {
      return null;
    }

    return (
      <AuthWrapper
        title="Sign In"
      >
        <SignInForm
          onSubmit={this.handleSubmit}
          changeState={this.changeState}
          errorMessage={errorMessage}
          working={working}
        />
      </AuthWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Authentication/SignIn.js